<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <div class="card-form" *ngIf="submitted">
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Claim Reported</span>
    </div>
    <div class="card-section top-section">
      <h2>Your claim has been reported</h2>
      <p class="section-hint">Claim Number: <strong>{{claimNo}}</strong></p>
      <p class="section-hint">Our claims team will be in touch. You can quote this claim number for any follow-up.</p>
      <div class="row-div margin-top-50">
        <button mat-button type="button" (click)="done()">
          <span class="button-text">Done</span>
        </button>
      </div>
    </div>
  </div>

  <form class="card-form" *ngIf="!submitted" [formGroup]="dpForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Report a Claim</span>
    </div>

    <div class="card-section top-section">
      <h2>Home Insurance policy details</h2>
      <p class="section-hint" *ngIf="policyNo">Policy No: {{policyNo}}</p>
      <p class="section-hint" *ngIf="insuredName">Insured: {{insuredName}}</p>

      <!-- <h2>Report a claim</h2> -->
      <p class="section-hint">Please fill in the details below</p>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Select type of loss or damage</mat-label>
        <mat-select formControlName="lossType" panelClass="form-select-popup" (blur)="logErrors()">
          <mat-option class="form-option" [value]="opt" *ngFor="let opt of lossTypeOptions">
            {{opt}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formErrors['lossType']">{{formErrors['lossType']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Date of loss</mat-label>
        <input matInput type="date" formControlName="lossDate" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['lossDate']">{{formErrors['lossDate']}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Time of loss</mat-label>
        <input matInput type="time" formControlName="lossTime">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Brief describe what happened</mat-label>
        <textarea matInput rows="4" formControlName="lossDescription" (blur)="logErrors()"></textarea>
        <mat-error *ngIf="formErrors['lossDescription']">{{formErrors['lossDescription']}}</mat-error>
      </mat-form-field>
    </div>

    <div class="card-section" formArrayName="claimItems">
      <h2>Items claimed (optional)</h2>
      <p class="section-hint">Add each item you are claiming for, if any</p>

      <div class="item-card" *ngFor="let item of claimItems.controls; let i = index" [formGroupName]="i">
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">Description of item</mat-label>
          <input matInput formControlName="itemDescription">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">Date purchased or received</mat-label>
          <input matInput type="date" formControlName="datePurchased">
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">Full name of the owner</mat-label>
          <input matInput formControlName="ownerName">
        </mat-form-field>
        <button mat-stroked-button type="button" (click)="removeClaimItem(i)">
          <span class="button-text">Remove item</span>
        </button>
      </div>

      <button mat-stroked-button type="button" (click)="addClaimItem()">
        <span class="button-text">+ Add item</span>
      </button>
    </div>

    <div class="card-section" *ngIf="showTheftDetails" formGroupName="theftDetails">
      <h2>Additional questions for theft, burglary and all risks claims</h2>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">When was the loss discovered? (date)</mat-label>
        <input matInput type="date" formControlName="discoveryDate">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">When was the loss discovered? (time)</mat-label>
        <input matInput type="time" formControlName="discoveryTime">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">By whom was the discovery made?</mat-label>
        <input matInput formControlName="discoveredBy">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">When was the property last seen? (date)</mat-label>
        <input matInput type="date" formControlName="lastSeenDate">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">When was the property last seen? (time)</mat-label>
        <input matInput type="time" formControlName="lastSeenTime">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">By whom was it last seen?</mat-label>
        <input matInput formControlName="lastSeenBy">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">When were the Police notified?</mat-label>
        <input matInput type="date" formControlName="policeNotifiedDate">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Address of Police Station</mat-label>
        <input matInput formControlName="policeStationAddress">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Other steps taken to recover the property</mat-label>
        <input matInput formControlName="recoverySteps">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Total value of contents at the time of theft</mat-label>
        <input matInput type="number" formControlName="totalContentsValue">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Anti-theft precautions: exterior doors</mat-label>
        <input matInput formControlName="exteriorDoorsSecurity">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Anti-theft precautions: interior doors</mat-label>
        <input matInput formControlName="interiorDoorsSecurity">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Anti-theft precautions: windows</mat-label>
        <input matInput formControlName="windowsSecurity">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Further anti-theft measures you intend to employ</mat-label>
        <textarea matInput rows="2" formControlName="furtherAntiTheftMeasures"></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Was a security guard on duty at the material time?</mat-label>
        <input matInput formControlName="securityGuardOnDuty">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">If so, name of the security company engaged</mat-label>
        <input matInput formControlName="securityCompanyName">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">Were the premises unoccupied? If so, when last occupied?</mat-label>
        <input matInput formControlName="premisesUnoccupied">
      </mat-form-field>
    </div>

    <div class="card-section">
      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">Cancel</span>
        </button>
        <button mat-button type="submit" [disabled]="!dpForm.valid">
          <span class="button-text">Save and Continue</span>
        </button>
      </div>
    </div>
  </form>
</div>
